import { Icon } from './types';

export const Check = ({ svgProps, pathProps }: Icon) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="check"
    {...svgProps}
  >
    <path
      d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2Z"
      fill="currentColor"
      {...pathProps}
    />
  </svg>
);
